import React from "react";
import { Link, useNavigate } from "react-router-dom";

function DeleteAccount() {
  const navigate = useNavigate();

  return (
    <div className="h-full bg-gradient-to-br from-indigo-50 via-purple-50 to-pink-50 overflow-y-auto">
      <div className="max-w-4xl mx-auto px-4 py-8 md:py-12">
        {/* Header */}
        <div className="text-center mb-8">
          <h1 className="text-3xl md:text-4xl font-bold bg-gradient-to-r from-red-600 to-pink-600 bg-clip-text text-transparent mb-4">
            🗑️ Delete Account
          </h1>
          <p className="text-lg text-gray-600 max-w-2xl mx-auto">
            You can request deletion of your account and associated personal data from Arabic Learning Hub.
          </p>
        </div>

        {/* Main Content */}
        <div className="bg-white/80 backdrop-blur-sm rounded-3xl p-6 md:p-8 shadow-xl border border-white/30">
          {/* How to Request Deletion */}
          <div className="mb-8">
            <h2 className="text-2xl font-bold text-gray-800 mb-4 flex items-center">
              <span className="text-2xl mr-3">📋</span>
              How to Request Deletion
            </h2>
            <div className="space-y-4">
              <div className="bg-blue-50 rounded-2xl p-4 border-l-4 border-blue-500">
                <p className="text-gray-700">
                  <strong>Option 1:</strong> If you are signed in, go to your profile/settings page and choose <strong>Delete Account</strong> (if available).
                </p>
              </div>
              <div className="bg-orange-50 rounded-2xl p-4 border-l-4 border-orange-500">
                <p className="text-gray-700">
                  <strong>Option 2:</strong> If the in‑app delete option is not visible, please email us from your account email with the subject <strong>"Delete My Account"</strong>.
                </p>
              </div>
            </div>
          </div>

          {/* Contact Information */}
          <div className="mb-8">
            <h2 className="text-2xl font-bold text-gray-800 mb-4 flex items-center">
              <span className="text-2xl mr-3">📧</span>
              Contact Information
            </h2>
            <div className="bg-gradient-to-r from-purple-100 to-pink-100 rounded-2xl p-6">
              <p className="text-lg text-gray-700 mb-2">Send your request to:</p>
              <a 
                href="mailto:support@arabiclearninghub.com" 
                className="text-xl font-bold text-purple-600 hover:text-purple-800 transition-colors duration-300"
              >
                support@arabiclearninghub.com
              </a>
            </div>
          </div>

          {/* What Happens Next */}
          <div className="mb-8">
            <h2 className="text-2xl font-bold text-gray-800 mb-4 flex items-center">
              <span className="text-2xl mr-3">⏳</span>
              What Happens Next
            </h2>
            <div className="space-y-3">
              <div className="flex items-start space-x-3">
                <div className="w-6 h-6 bg-green-500 rounded-full flex items-center justify-center flex-shrink-0 mt-1">
                  <span className="text-white text-sm font-bold">1</span>
                </div>
                <p className="text-gray-700">We will verify your identity via your account email.</p>
              </div>
              <div className="flex items-start space-x-3">
                <div className="w-6 h-6 bg-green-500 rounded-full flex items-center justify-center flex-shrink-0 mt-1">
                  <span className="text-white text-sm font-bold">2</span>
                </div>
                <p className="text-gray-700">Upon verification, your account and associated personal data will be permanently deleted, subject to legal obligations.</p>
              </div>
              <div className="flex items-start space-x-3">
                <div className="w-6 h-6 bg-green-500 rounded-full flex items-center justify-center flex-shrink-0 mt-1">
                  <span className="text-white text-sm font-bold">3</span>
                </div>
                <p className="text-gray-700">You will receive a confirmation once deletion is complete.</p>
              </div>
            </div>
          </div>

          {/* Important Notice */}
          <div className="bg-red-50 rounded-2xl p-6 border border-red-200">
            <h3 className="text-lg font-bold text-red-800 mb-3 flex items-center">
              <span className="text-xl mr-2">⚠️</span>
              Important Notice
            </h3>
            <p className="text-red-700">
              If you accidentally requested deletion, contact us immediately at <strong>support@arabiclearninghub.com</strong> to attempt cancellation before it is processed.
            </p>
          </div>

          {/* Delete Account Button */}
          <div className="mt-8 text-center">
            <button
              onClick={() => {
                if (window.confirm('Are you sure you want to delete your account?')) {
                  // Add delete logic here
                  navigate('/');
                }
              }}
              className="bg-red-600 text-white px-4 py-2 rounded hover:bg-red-700 transition-all duration-300"
            >
              Delete Account
            </button>
          </div>

          {/* Back Button */}
          <div className="mt-4 text-center">
            <Link
              to="/"
              className="inline-flex items-center px-6 py-3 bg-gradient-to-r from-purple-500 to-pink-500 text-white font-semibold rounded-2xl hover:from-purple-600 hover:to-pink-600 transition-all duration-300 hover:scale-105 shadow-lg hover:shadow-xl"
            >
              <span className="mr-2">←</span>
              Back to Home
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
}

export default DeleteAccount;
